export default () => {
  if (typeof localStorage === 'undefined' || typeof window?.location === 'undefined') {
    return;
  }
  localStorage.setItem('init-route', window?.location.href);
};
